import Vue from 'vue'
import Vuex from 'vuex'
import request from '../utils/request'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    token: localStorage.getItem('token') || '',
    sidebar: {
      opened: true
    },
    menuList: JSON.parse(localStorage.getItem('menuList') || '[]')
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
      sessionStorage.setItem('token', token)
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebar.opened = !state.sidebar.opened
    },
    LOGOUT(state) {
      // 保留记住的登录账号信息，清除其他所有缓存
      const rememberedUser = localStorage.getItem('rememberedUser')
      localStorage.clear()
      sessionStorage.clear()
      if (rememberedUser) {
        localStorage.setItem('rememberedUser', rememberedUser)
      }
      state.user = null
      state.token = ''
      state.menuList = []
    },
    SET_MENU_LIST(state, menuList) {
      state.menuList = menuList
      localStorage.setItem('menuList', JSON.stringify(menuList))
    }
  },
  actions: {
    login({ commit, dispatch }, { email, password, check_code_value, check_code_key, remember }) {
      return new Promise((resolve, reject) => {
        // console.log('=== 开始登录 ===')
        // console.log('登录参数:', { email, password, remember })
        
        request.post('/v2/login/login', {
          email,
          password,
          check_code_value,
          check_code_key,
          remember
        })
        .then(response => {
          // console.log('登录接口响应:', response)
          // console.log('响应data:', response.data)
          
          // 登录前清空旧账号的所有缓存（保留记住的登录账号信息）
          const rememberedUser = localStorage.getItem('rememberedUser')
          localStorage.clear()
          sessionStorage.clear()
          if (rememberedUser) {
            localStorage.setItem('rememberedUser', rememberedUser)
          }
          
          const { access_token, user_info } = response.data
          // console.log('解析出的token:', access_token)
          // console.log('解析出的用户信息:', user_info)
          
          commit('SET_TOKEN', access_token)
          commit('SET_USER', user_info)
          
          // console.log('=== 登录成功，开始获取菜单 ===')
          dispatch('getMenuList').then(() => {
            // console.log('=== 菜单获取成功 ===')
            resolve(response)
          }).catch(err => {
            // console.error('获取菜单失败:', err)
            reject(err)
          })
        })
        .catch(error => {
          console.error('登录失败:', error)
          reject(error)
        })
      })
    },
    getMenuList({ commit }) {
      return new Promise((resolve, reject) => {
        request.get('/v2/menu/getMenuList')
        .then(response => {
          // console.log('菜单接口响应:', response)
          // console.log('菜单数据:', response.data)
          const menuList = response.data || []
          // console.log('处理后的菜单列表:', menuList)
          commit('SET_MENU_LIST', menuList)
          resolve(menuList)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    getEmailCode({ }, { email, type }) {
      return new Promise((resolve, reject) => {
        request.post('/v2/login/getEmailCode', {
          email,
          type
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    
    register({ commit }, params) {
      return new Promise((resolve, reject) => {
        console.log('=== 注册请求参数 ===')
        console.log('所有参数:', params)
        request.post('/v2/login/register', params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    
    resetPassword({ }, { email, code, password, ret_password }) {
      return new Promise((resolve, reject) => {
        request.post('/v2/login/resetPassword', {
          email,
          code,
          password,
          ret_password
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        request.post('/v2/login/logout')
        .then(() => {
          commit('LOGOUT')
          resolve()
        })
        .catch(error => {
          commit('LOGOUT')
          reject(error)
        })
      })
    },
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    sidebarOpened: state => state.sidebar.opened,
    menuList: state => state.menuList
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js